import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ValueSection.module.scss';
import collageImg from '../../../assets/images/Landing/bodhiwell-valor-composicion.png';

export const ValueSection: React.FC = () => {
    const { t } = useTranslation();

    const CARDS = [
        { title: t('landing.value.cards.visibility.title', 'Visibilidad'), desc: t('landing.value.cards.visibility.desc', 'Damos lugar a tu perfil para que más personas conozcan tu trabajo y tu forma de acompañar.') },
        { title: t('landing.value.cards.community.title', 'Comunidad profesional'), desc: t('landing.value.cards.community.desc', 'Conectá con colegas de distintos recorridos en un espacio colaborativo.') },
        { title: t('landing.value.cards.tools.title', 'Herramientas digitales'), desc: t('landing.value.cards.tools.desc', 'Ordená tu presencia, disponibilidad y gestión dentro de la plataforma.') },
        { title: t('landing.value.cards.exchange.title', 'Intercambio'), desc: t('landing.value.cards.exchange.desc', 'Un entorno para que distintas miradas puedan dialogar y enriquecerse.') },
        { title: t('landing.value.cards.content.title', 'Contenido de valor'), desc: t('landing.value.cards.content.desc', 'Información clara y significativa para ampliar la comprensión del bienestar.') },
        { title: t('landing.value.cards.support.title', 'Acompañamiento'), desc: t('landing.value.cards.support.desc', 'Formá parte de una red viva donde tu práctica pueda crecer con sentido.') }
    ];

    return (
        <section className={styles['value-section']} id="value">
            <div className={styles['container']}>
                <div className={styles['header']}>
                    <p className={styles['eyebrow']}>{t('landing.value.eyebrow', 'VALOR')}</p>
                    <h2 className={styles['title']}>{t('landing.value.title', 'Valor que impulsa tu práctica')}</h2>
                    <p className={styles['subtitle']}>{t('landing.value.subtitle', 'Un espacio para hacer visible tu trabajo, conectar con otros profesionales y participar de una comunidad que promueve una forma más humana, colaborativa e integradora de acompañar la salud.')}</p>
                </div>

                <div className={styles['collage-container']}>
                    <img src={collageImg} alt="Bodhiwell collage" className={styles['collage-image']} />
                </div>

                <div className={styles['cards-grid']}>
                    {CARDS.map((card, i) => (
                        <div key={i} className={styles['card']}>
                            <h3 className={styles['card-title']}>{card.title}</h3>
                            <p className={styles['card-desc']}>{card.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
